// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import PageLayout from "examples/LayoutContainers/PageLayout";

// Authentication pages components
import Footer from "layouts/authentication/components/Footer";
import { useEffect } from "react";
import { getFromStorage } from "helpers";
import { STORAGE_KEYS } from "helpers";
import { useAppDispatch } from "hooks/store";
import { setCredentials } from "reducers/authSlice";

function CommonLayout({ image, children }) {
  const usedispatch = useAppDispatch();

  useEffect(() => {
    const token = getFromStorage(STORAGE_KEYS.token);

    if (token) {
      usedispatch(
        setCredentials({
          user: null,
          token: token,
        })
      );
    }
  }, []);

  return (
    <PageLayout>
      {/* <DefaultNavbar
        action={{
          type: "external",
          route: "https://creative-tim.com/product/material-dashboard-react",
          label: "free download",
          color: "dark",
        }}
      /> */}
      <MDBox
        position="absolute"
        width="100%"
        minHeight="100vh"
        sx={{
          backgroundImage: ({
            functions: { linearGradient, rgba },
            palette: { gradients },
          }) =>
            image &&
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${image})`,
          backgroundSize: "contain",
          opacity: 0.1,
          backgroundPosition: "center",
          // marginTop: 150,
        }}
      />
      <MDBox px={1} width="100%" height="100vh" mx="auto">
        <Grid
          container
          spacing={1}
          justifyContent="center"
          alignItems="start"
          height="100%"
        >
          <Grid item xs={11} sm={11} md={11} lg={11} xl={11}>
            {children}
          </Grid>
        </Grid>
      </MDBox>
      {/* <Footer dark /> */}
    </PageLayout>
  );
}

// Typechecking props for the CommonLayout
CommonLayout.propTypes = {
  image: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default CommonLayout;
